import React from 'react';

const Mail = (props) => (
    <a class="text-lg" href='mailto:hello@comcom.chat'>hello@comcom.chat</a>
)

export default Mail;
